import axios from "axios";
import toast from "react-hot-toast";

export const PARK_ADMIN_BULK_UPLOAD_REQUEST = "PARK_ADMIN_BULK_UPLOAD_REQUEST";
export const PARK_ADMIN_BULK_UPLOAD_SUCCESS = "PARK_ADMIN_BULK_UPLOAD_SUCCESS";
export const PARK_ADMIN_BULK_UPLOAD_FAILURE = "PARK_ADMIN_BULK_UPLOAD_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const uploadParkAdminBulk = (formData) => async (dispatch) => {
  dispatch({ type: PARK_ADMIN_BULK_UPLOAD_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/admin/bulkParkAdminUpload`,
      formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    dispatch({
      type: PARK_ADMIN_BULK_UPLOAD_SUCCESS,
      payload: response.data,
    });

    toast.success("Park Admin data uploaded successfully!");
  } catch (error) {
    dispatch({
      type: PARK_ADMIN_BULK_UPLOAD_FAILURE,
      payload: error?.response?.data?.message || error.message,
    });

    toast.error("Upload failed!");
  }
};
